import React from 'react'
import './footer.css';

const KOFI_URL = 'https://ko-fi.com/jihoon87956';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-container" role="contentinfo">
            <div className="container-fluid">
                <div className="support">
                    <a
                        className="support-link"
                        href={KOFI_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span role="img" aria-label="coffee">☕</span> Support on Ko-fi
                    </a>
                    <p className="support-text">
                        Independent CTCAE reference tool. If this helps your work, consider supporting development.
                    </p>
                </div>
                <p className="title">
                    Copyright ©{currentYear} Jihoon. All rights reserved.
                    {' · '}
                    <a className="privacy-link" href="/privacy/">
                        Privacy Policy
                    </a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/component/footer/footer.js